import { useUrlGenerator } from '@folklore/routes';
import React, { use, useMemo } from 'react';

import Api from '../lib/api/Api';

const ApiContext = React.createContext(null);

export const useApi = () => use(ApiContext);

interface ApiProviderProps {
    api?: Api | null;
    children?: React.ReactNode | null;
}

export const ApiProvider = ({ api: initialApi = null, children = null }: ApiProviderProps) => {
    const generateUrl = useUrlGenerator();
    const api = useMemo(() => {
        if (initialApi !== null) {
            return initialApi;
        }
        return new Api({
            generateUrl,
        });
    }, [generateUrl, initialApi]);
    return <ApiContext value={api}>{children}</ApiContext>;
};

export default ApiContext;
